import React from "react";
import "./CarCard.css";
const CarCard = () => {
  return (
    <>
      <div className="car-card-container">
      <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Mahindra-Major.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Camper.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia SUV cars for your next adventure!</p>
            <button className="car-card-button">Learn More</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Scorpio-Gateway.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">Learn More</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Scorpio-S11.png" L alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Scorpio-N.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Mahindra-Thar.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/XUV500-Sportz.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/XUV-700.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Thar-Roxx.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Tata-Safari-Storme.png" L alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Tata-Safari.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Toyota-Fortuner-Legender.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Toyota-Fortuner.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Toyota-Hilux.png" L alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Ford-Endeavour.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage//MG-Gloster.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Force-Gurkha.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Force-Gurkha-five-door.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Force-One.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Jeep-Grandcherokee-Laredo.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Jeep-Wrangler.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Mitsubishi-Pajero.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/1.jpeg" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/1.jpeg" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best luxury cars for your next adventure!</p>
            <button className="car-card-button">RESERVE</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarCard;
